import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import memoizeOne from 'memoize-one';
import AuthorizeFilters from './AuthorizeFilters';
import { debounceGenerateOvertimeReport } from '../../../requests/overtimeRecord';
import { sendAlert } from '../../../actions/utils';
import { ComponentDataTable } from '../../../components';
import AuthorizeOvertimeFilterDatatable from './AuthorizeOvertimeFilterDatatable';

const columns = memoizeOne(() => [
  {
    name: 'Nombre',
    selector: 'name',
    cell: item => <>{item.full_name}</>,
    sortable: false,
    grow: '2'
  },
  {
    name: 'Cédula de identidad (RUT)',
    selector: 'national_identification',
    sortable: false,
    grow: '1'
  }
]);

export const WorkdayExpander = props => {
  const { data, currentEmployee, onSuccess } = props;
  const { attendances } = data;

  return (
    <AuthorizeOvertimeFilterDatatable
      attendances={attendances}
      currentEmployee={currentEmployee}
      onSuccess={onSuccess}
      employee={data}
    />
  );
};

const AuthorizeOvertimes = () => {
  const [moreData, setMoreData] = useState(false);
  const [filters, setFilters] = useState();
  const [employees, setEmployees] = useState([]);
  const [amount, setAmount] = useState(0);
  const [setDocumentModalBody] = useState('');
  const [setDocumentModalShow] = useState(false);
  const [onRequest, setOnRequest] = useState(false);
  const [searchFirstStart, setSearchFirstStart] = useState(false);
  const [isSubmitting, setSubmitting] = useState(false);
  const { currentEmployee } = useSelector(state => state.auth);
  const dispatch = useDispatch();

  const handleFailureRequest = error => {
    const message = error?.response?.data?.message || 'TRABAJADOR NO ENCONTRADO';
    dispatch(sendAlert({ kind: 'error', message }));
  };

  const handleRequest = params => {
    const customParams = {
      ...params
    };
    const dateRange = params.range_date_workday;
    setOnRequest(true);

    if (dateRange.length > 0) {
      debounceGenerateOvertimeReport({
        dispatch,
        params: {
          display_start: 0,
          display_length: 15,
          ...customParams,
          sort_direction: 'asc',
          sort_column: 'name',
          is_dt: false,
          paginate: true
        },
        format: '.json',
        responseType: 'json',
        successCallback: response => {
          const { data } = response;
          setAmount(data.metadata.amount);
          setEmployees(data.data);
        },
        failureCallback: handleFailureRequest,
        callback: () => {
          setOnRequest(false);
          setSubmitting(false);
        }
      });
    } else {
      setOnRequest(false);
      setSubmitting(false);
    }
  };

  const handleFilterAdvance = async params => {
    setFilters(params);
    setSubmitting(true);
    setSearchFirstStart(true);
    setMoreData(!moreData);
    handleRequest({ ...params, ...filters });
  };

  const refreshTable = () => {
    if (filters) {
      setOnRequest(true);
      handleRequest({ ...filters });
    } else {
      setMoreData(prev => !prev);
    }
  };

  return (
    <>
      <AuthorizeFilters formRequest={handleFilterAdvance} isSubmit={isSubmitting} currentEmployee={currentEmployee} />
      <div className="data-table-yellow">
        <ComponentDataTable
          onRequest={onRequest}
          columns={columns()}
          moreData={moreData}
          data={employees}
          responsive
          totalRows={amount}
          resourceRequest={params => {
            handleRequest({ ...params, ...filters });
          }}
          expandableRows
          expandableRowExpanded={() => true}
          expandableRowsComponent={
            <WorkdayExpander
              setDocumentModalBody={setDocumentModalBody}
              setDocumentModalShow={setDocumentModalShow}
              currentEmployee={currentEmployee}
              onSuccess={refreshTable}
            />
          }
          searchFirstStart={searchFirstStart}
        />
      </div>
    </>
  );
};

export default AuthorizeOvertimes;
